import { format } from "date-fns";

// Value can either have a UTC timezone (ends with `Z`) or no timezone specified.
// In either case, we want to display the value as local time.
export function parseStringToDate(input: string): Date {
    const valueWithoutTz = input.endsWith("Z") ? input.substring(0, input.length - 1) : input;

    return new Date(valueWithoutTz);
}

// `Date` object uses UTC internally, so when converting to JSON it'll return the datetime in UTC.
// However, we want to have the local representation instead. Which means we'll format without any
// timezone offset.
export function parseDateToString(input: Date, fmt: "datetime" | "date" = "datetime"): string {
    return fmt === "datetime" ? format(input, "yyyy-MM-dd'T'HH:mm:ss.SSS") : format(input, "yyyy-MM-dd");
}
